<ng-container [formGroup]="form">
  <div class="grid-x">
    <div class="cell large-12 medium-12 small-12 bold">
      <div class="section-header" [ngClass]="{ 'active' : activeStep == step }" (click)="toggleOpen()">
        <span class="margin-right">Step 1: Verify Owner Information</span>
        <button class="icon-button">
          @if (isOpen == false) {
            <svg-icon icon="icon-caret-right"></svg-icon>
          }
          @if (isOpen == true) {
            <svg-icon icon="icon-caret-down"></svg-icon>
          }
        </button>
      </div>
    </div>
  </div>
  <div class="grid-x margin-top" [ngClass]="{ 'hideSection': isOpen == false }">
    <div class="cell large-2 medium-2 small-6 text-align-right">
      <span class="bold padding-right">Applicant Name:</span>
    </div>
    <div class="cell large-4 medium-4 small-6">
      <input type="text" formControlName="name" />
    </div>
    <div class="cell large-2 medium-2 small-6 text-align-right">
      <span class="bold padding-left padding-right">Owner Number:</span>
    </div>
    <div class="cell large-4 medium-4 small-6">
      <input type="text" formControlName="id" />
    </div>
    <div class="cell large-12 medium-12 small-12">
      <div class="grid-x" formGroupName="address">
        <div class="cell large-2 medium-2 small-6 padding-right text-align-right bold">
          Street Address:
        </div>
        <div class="cell large-4 medium-4 small-6">
          <input type="text" formControlName="street" />
        </div>
        <div class="cell large-2 medium-2 small-6 padding-right text-align-right bold">
          Suite:
        </div>
        <div class="cell large-4 medium-4 small-6">
          <input type="text" formControlName="suite" />
        </div>
        <div class="cell large-2 medium-4 small-6 padding-right text-align-right bold">
          P.O.Box:
        </div>
        <div class="cell large-4 medium-4 small-6">
          <input type="text" formControlName="poBox" />
        </div>
        <div class="cell large-6 medium-6 small-6"></div>
        <div class="cell large-2 medium-2 small-6 text-align-right">
          <span class="bold padding-right">City:</span>
        </div>
        <div class="cell large-2 medium-2 small-6">
          <input type="text" formControlName="city" />
        </div>
        <div class="cell large-2 medium-2 small-6 text-align-right">
          <span class="bold padding-right">State:</span>
        </div>
        <div class="cell large-2 medium-2 small-6">
          <input type="text" formControlName="state" />
        </div>
        <div class="cell large-2 medium-2 small-6 text-align-right">
          <span class="bold padding-right">Zip Code:</span>
        </div>
        <div class="cell large-2 medium-2 small-6">
          <input type="text" formControlName="zip" />
        </div>
      </div>
    </div>
    <div class="cell large-2 medium-2 small-6 text-align-right">
      <span class="bold padding-right">Phone Number:</span>
    </div>
    <div class="cell large-4 medium-4 small-6">
      <input type="text" formControlName="phone" />
    </div>
    <div class="cell large-2 medium-2 small-6 text-align-right">
      <span class="bold padding-left padding-right">Email Address:</span>
    </div>
    <div class="cell large-4 medium-4 small-6">
      <input type="text" formControlName="email" />
    </div>
  </div>
</ng-container>